<template>
  <div>
    <root-header :admin="admin" />
    <root-content>
      <router-view></router-view>
    </root-content>

    <pb-confirm
      :show="confirm.show"
      :title="confirm.title"
      :content="confirm.content"
      @confirm="confirm.onConfirm"
      @close="confirmClose"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import RootHeader from "@/common/RootHeader";
import RootContent from "@/common/RootContent";

export default {
  name: "RootPage",
  props: {},
  computed: {
    ...mapState({
      user: "user",
      confirm: "confirm",
    }),

    admin() {
      return this.user.position === "구성원";
    },
  },
  methods: {
    confirmClose() {
      if (typeof this.confirm.onClose === "function") {
        this.confirm.onClose();
      }
      this.$confirm.hide();
    },
  },
  components: {
    RootHeader,
    RootContent,
  },
};
</script>
<style lang="scss"></style>
